import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { JhiEventManager } from 'ng-jhipster';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { Faculty, Queue } from '../../../../models';
import { FacultyService } from '../../../../services';
import { Router } from '@angular/router';
import { QUEUE_LIST_MODIFICATION } from '../../../../shared/constants';

@Component({
    selector: 'qms-faculty-navigation-menu-element',
    templateUrl: './faculty-navigation-menu-element.component.html'
})
export class FacultyNavigationMenuElementComponent implements OnInit, OnDestroy {

    @Input()
    public faculty: Faculty;

    @Input()
    public onlyCategoryQueues: boolean;

    public link: any[];

    public queues: Observable<Array<Queue>>;

    private queueSubscription: Subscription;

    constructor(private facultyService: FacultyService,
                private eventManager: JhiEventManager,
                private router: Router) {
        this.queues = new Observable<Array<Queue>>();
    }

    ngOnInit() {
        this.loadQueues();
        this.registerChangeInQueues();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.queueSubscription);
    }

    public routeToQueue(event) {
        if (event === this.faculty) {
            this.queues.first().subscribe((queues: Queue[]) => {
                if (queues.length !== 0) {
                    this.router.navigate(['/queue-handling', queues[0].id]);
                }
            });
        }
    }

    private loadQueues() {
        this.queues = this.facultyService.findQueues(this.faculty.id);
    }

    private registerChangeInQueues() {
        this.queueSubscription = this.eventManager.subscribe(QUEUE_LIST_MODIFICATION, (response) => {
            this.loadQueues();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/queues-handling/queues-handling-navigation-menu/faculty-navigation-menu-element/faculty-navigation-menu-element.component.ts